import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';

import { HeaderComponent } from './components/header';
import { SidenavComponent } from './components/sidenav';
import { FooterComponent } from './components/footer';
import { RouterModule } from '@angular/router';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { SidenavMenuItemComponent } from './components/sidenav-menu-item';
import { AvisoRpaComponent } from './components/aviso-rpa';
import { ReactiveFormsModule } from '@angular/forms';

const COMPONENTS = [
  HeaderComponent,
  SidenavComponent,
  FooterComponent,
  AvisoRpaComponent,
];

@NgModule({
  declarations: [...COMPONENTS, SidenavMenuItemComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,

    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    PipesModule,

    FontAwesomeModule,
    NgOptimizedImage,
  ],
  exports: COMPONENTS,
  providers: [],
})
export class SharedModule {}
